import PatchOps from '@leverege/api-patch-ops'
import { updateDevice } from './DeviceActions'

/*
  Usage:
    let updater = DeviceUpdater( dispatch, system )
      .set( "a/string/to/a/path", "value 1" )
      .set( "a/string/to/another/path", "value 2" )
      .done();
 */

function DeviceUpdater( dispatch, system, key, value ) {
  
  const patchOps = PatchOps( key, value );

  patchOps.done = function( ) {
    dispatch( updateDevice( system, patchOps.ops() ) );

  }  

  return patchOps;
}

module.exports = DeviceUpdater;
